/***
 * @Authors:
 *      Rahul
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Style imports */
import './styles.css'
import Gutter from "../../../Gutter/Gutter";
/*** End Imports ***/

const LoadingViewSmall = (props) => {

    // helper function
    // event handlers for static component

    return (
        <div>
            <div className = "animated-background"
                 style={{height: 'fit-content',
                     flex : "1",
                     position : "relative",
                     minWidth : "340px",
                     marginRight : "0px"
                 }}
            >
                <div style={{paddingTop: '0'}}>
                    <div className="background-masker job-info-top">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-logo-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-logo-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-logo-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>

                    <div className="background-masker job-info-company-name-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-company-name-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-company-name-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-company-title-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-company-title-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker job-info-company-title-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                </div>
                <div style={{paddingTop: '214px'}}></div>
            </div>

            <Gutter height={40}/>

            <div className = "animated-background"
                 style={{height: 'fit-content',
                     flex : "1",
                     position : "relative",
                     minWidth : "340px",
                     marginRight : "0px"
                 }}
            >
                <div style={{paddingTop: '0'}}>

                    <div className="background-masker dbi-top">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-profile-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-profile-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-profile-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>

                    <div className="background-masker dbi-profile-box-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-profile-box-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-profile-box-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>

                </div>

                <div style={{paddingTop: "117px"}}>
                    <div className="background-masker dbi-section-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-section-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-section-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                </div>

                <div style={{paddingTop: "37px"}}>
                    <div className="background-masker dbi-section-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-section-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-section-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                </div>

                <div style={{paddingTop: "37px"}}>
                    <div className="background-masker dbi-section-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-section-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-section-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                </div>

                <div style={{paddingTop: "37px"}}>
                    <div className="background-masker dbi-button-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-button-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker dbi-button-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                </div>

                <div style={{paddingTop: '60px'}}></div>
            </div>
        </div>

    );
};

/**
 * all prop types which can be passed to this component
 */
LoadingViewSmall.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
LoadingViewSmall.defaultProps ={

};

export default LoadingViewSmall;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/LoadingView/LoadingViewSmall.js